import React from "react";

import { Button } from "../Component";
import RichTextEditor from "../input/rich-text/RichTextEditor";
import { LANGUAGES } from "./MultiLanguageInput";
import { createEmptyRichMultiLanguage } from "../../utilities/vacancyUtils";

// Ko'p tilli qatorlar ro'yxati (talablar, ko'nikmalar va h.k.).
// Har bir qator uchala tilda rich text sifatida tahrirlanadi.
const MultiLanguageListInput = ({
  label,
  items,
  onChange,
  addButtonTitle,
  bare = false,
}) => {
  const handleItemChange = (index, languageKey, newValue) =>
    onChange(
      items.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [languageKey]: newValue } : item
      )
    );

  const handleAdd = () => onChange([...items, createEmptyRichMultiLanguage()]);

  const handleRemove = (index) =>
    onChange(items.filter((_, itemIndex) => itemIndex !== index));

  const content = (
    <>
      {items.length === 0 && (
        <div className="form-note mb-3">Hozircha qator qo'shilmagan.</div>
      )}

      {items.map((item, index) => (
        <div className="bg-lighter rounded p-3 mb-3" key={index}>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <span className="badge badge-dim badge-primary">{index + 1}</span>
            <Button
              color="white"
              className="btn-icon btn-trigger text-danger"
              iconName="trash"
              onClick={(e) => {
                e.preventDefault();
                handleRemove(index);
              }}
            />
          </div>

          {LANGUAGES.map((language) => (
            <div className="mb-2" key={language.key}>
              <div className="overline-title text-soft mb-1">
                {language.short}
              </div>
              <RichTextEditor
                value={item?.[language.key]}
                setValue={(newValue) =>
                  handleItemChange(index, language.key, newValue)
                }
                autoFocus={false}
              />
            </div>
          ))}
        </div>
      ))}

      <Button
        color="white border-light"
        className="mt-1"
        onClick={(e) => {
          e.preventDefault();
          handleAdd();
        }}
        iconName="plus"
        title={addButtonTitle ?? "Add"}
      />
    </>
  );

  if (bare) return content;

  return (
    <div className="border rounded p-3 mb-3 bg-white">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <label className="form-label mb-0">{label}</label>
        <span className="badge badge-dim badge-light">{items.length}</span>
      </div>
      {content}
    </div>
  );
};

export default MultiLanguageListInput;
